import React from 'react';
import ReportCard from './ReportCard';

function index({ title, text, color, imgIcon }) {
    return (
        <ReportCard title={title} text={text} color={color} imgIcon={imgIcon} />
    );
}

export default index;